import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing, palette }) => ({
  anchorEl: {
    transform: `translateY(${spacing(6)}px) translateX(${spacing(2)}px)`,
  },
  paper: {
    boxShadow: `0 ${spacing(1)}px ${spacing(2)}px 0 ${palette.grey[300]}`,
    borderRadius: 4,
    padding: 0,
    border: `solid 1px ${palette.grey[300]}`,
  },
  button: {
    display: "flex",
    alignItems: "center",
    fontSize: 16,
    textDecoration: "none",
    color: colors.black,
    whiteSpace: "nowrap",
    "&:hover": {
      textDecoration: "none",
    },
    "&:disabled": {
      color: colors.black,
    },
  },
  buttonIcon: {
    marginLeft: 5,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 16,
  },
}));

export default useStyles;
